import BrowseModelsStore from "@/areas/inventory/stores/BrowseModelsStore";
import CreateModelStore from "@/areas/inventory/stores/CreateModelStore";
import CreateItemStore from "@/areas/inventory/stores/CreateItemStore";
import AddItemToWatchlistStore from "@/areas/inventory/stores/AddItemToWatchlistStore";
import RemoveItemFromWatchlistStore from "@/areas/inventory/stores/RemoveItemFromWatchlistStore";
import BrowseItemWatchlistStore from "@/areas/inventory/stores/BrowseItemWatchlistStore";
import InventoryDashboardStore from "@/areas/inventory/stores/InventoryDashboardStore";
import ExportModelsStore from "@/areas/inventory/stores/ExportModelsStore";
import BrowseEntitiesStore from "@/areas/inventory/stores/BrowseEntitiesStore";
import CreateEntityStore from "@/areas/inventory/stores/CreateEntityStore";
import BrowseCustomFieldsStore from "@/areas/inventory/stores/BrowseCustomFieldsStore";
import BrowseLabelsStore from "@/areas/inventory/stores/BrowseLabelsStore";
import CreateLabelStore from "@/areas/inventory/stores/CreateLabelStore";
import BrowseSegmentsStore from "@/areas/inventory/stores/BrowseSegmentsStore";
import CreateSegmentStore from "@/areas/inventory/stores/CreateSegmentStore";
import SchedulerActivityStore from "@/areas/inventory/stores/SchedulerActivityStore";

export default class InventoryRootStore {
  constructor(parentStore) {
    this.parentStore = parentStore;

    this.browseModelsStore = new BrowseModelsStore(this);
    this.createModelStore = new CreateModelStore(this);
    this.browseEntitiesStore = new BrowseEntitiesStore(this);
    this.createEntityStore = new CreateEntityStore(this);
    this.createItemStore = new CreateItemStore(this);
    this.browseItemWatchlistStore = new BrowseItemWatchlistStore(this);
    this.addItemToWatchlistStore = new AddItemToWatchlistStore(this);
    this.removeItemFromWatchlistStore = new RemoveItemFromWatchlistStore(this);
    this.dashboardStore = new InventoryDashboardStore(this);
    this.exportModelsStore = new ExportModelsStore(this);
    this.browseCustomFieldsStore = new BrowseCustomFieldsStore(this);
    this.browseLabelsStore = new BrowseLabelsStore(this);
    this.createLabelStore = new CreateLabelStore(this);
    this.browseSegmentsStore = new BrowseSegmentsStore(this);
    this.createSegmentStore = new CreateSegmentStore(this);
    this.schedulerActivityStore = new SchedulerActivityStore(this);
  }
}
